module.exports = __webpack_public_path__ + "img/BOTELLAHONEY.f02410ae.png";